import React from "react";
import { Button, Form } from "react-bootstrap";
import "./pagination.css";

/**
 * Pagination Component
 * 
 * Manages table pagination with page navigation and result count display.
 * Displays current page, results per page, and total results. Provides navigation
 * controls to change pages and handles data fetching for requested page.
 * 
 * @param {Object} props - Component props
 * @param {string} props.argument - Filter/sort argument for backend query
 * @param {Object} props.tableData - Table data with pagination metadata
 * @param {Function} props.changeFilters - Callback to change page
 * @param {number} props.page - Current page number
 * @param {boolean} props.isLoading - Loading state indicator
 * @returns {JSX.Element} Pagination controls and results information
 */
const Pagination = ({ props }) => {
  const { argument, tableData, changeFilters, page, isLoading } = props;

  // useEffect(() => {
  //   console.log("page", page);
  // }, [page]);

  return (
    <div className="shutdowndatafilters">
      {page.lastPage === 0 ? (
        <></>
      ) : (
        <>
          <div className="filterrowshow">
            <p>Show rows: </p>
            <Form.Select
              value={argument.numOfRows}
              name="numOfRows"
              onChange={changeFilters}
              className="filterrowselect"
              disabled={isLoading}
            >
              <option>50</option>
              {argument.searchTerm === "" ||
                argument.selectedHeader === "" ||
                argument.selectedDropdown === "" ? (
                <>
                  <option>100</option>
                  <option>500</option>
                </>
              ) : (
                ""
              )}
            </Form.Select>
          </div>
          <div className="filtercontainer">
            <div className="filterrownumber">
              {argument.searchTerm === "" ||
                argument.selectedHeader === "" ||
                argument.selectedDropdown === "" ? (
                <span>
                  {page.startNum
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  -
                  {page.endNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                  of{" "}
                  {tableData.total
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </span>
              ) : (
                <span>
                  1-
                  {tableData.results.length
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                  of{" "}
                  {tableData.total
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </span>
              )}
            </div>
            <div className="filterpagination">
              {argument.currentPage !== 1 && page.lastPage !== 0 ? (
                <Button
                  name="firstPage"
                  onClick={changeFilters}
                  className="filterpage"
                  disabled={isLoading}
                >
                  First
                </Button>
              ) : (
                ""
              )}
              {argument.currentPage > 1 ? (
                <Button
                  name="prevPage"
                  onClick={changeFilters}
                  className="filterpage"
                  disabled={isLoading}
                >
                  Prev
                </Button>
              ) : (
                ""
              )}
              {argument.currentPage < page.lastPage ? (
                <Button
                  name="nextPage"
                  onClick={changeFilters}
                  className="filterpage"
                  disabled={isLoading}
                >
                  Next
                </Button>
              ) : (
                ""
              )}
              {argument.currentPage !== page.lastPage && page.lastPage !== 0 ? (
                <Button
                  name="lastPage"
                  onClick={changeFilters}
                  className="filterpage"
                  disabled={isLoading}
                >
                  Last
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Pagination;
